import './styles.scss';
//core
import { useState, useEffect } from 'react';

//components
import NormalTable from 'Components/Common/Table';
import Pagination from 'Components/Pagination';
import Modal from 'Components/Common/Modal';
import Button from 'Components/Button';

//redux
import { useDispatch } from 'react-redux';
import { manageUsersDataFetch, manageUsersSendInvite } from '../../../../../Redux/Slices/companyManagementSlice';
import { notifySuccess } from 'Services/Utils/toastNotification';
import { useParams } from "react-router-dom";

function ManageUsers() { 
    const dispatch = useDispatch();
    const headerDetails = [
        {
          label: "S No",
          sortKey: false,
        },
        {
          label: "Users Name",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "firstname"})
          },
        },
        {
          label: "Mobile Number",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "mobile"})
          },
        },
        {
          label: "Email ID",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "email"})
          },
        },
        {
          label: "Position",
          sortKey: false,
        },
        {
          label: 'Added by',
          sortKey: false,
        }
      ]
    const [userData, setUserData] = useState([])  
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sortOptions, setSortOptions] = useState({ sort_by: true, order_by: "createdAt" });
    const {id:companyId} = useParams();
    const handlePageChange = (page) => {
      setCurrentPage(page);
    }; 

    const sendInvite = (id,email) => {
      // console.log(id,email);
      dispatch(
        manageUsersSendInvite({
          data:{
            id,email
          },
          callBack:(value)=>{
            notifySuccess("Invite Sent Successfully")
            setRefresh(!refresh)
          }
        })
      )
      
    }

   useEffect(()=>{
    dispatch(manageUsersDataFetch({
      data:{
        companyID:companyId,
        page:currentPage,
        limit:10,
        sort_by:sortOptions.sort_by?"ASC":"DESC",
        order_by: sortOptions.order_by, 
      },
      callBack:(value)=>{
        console.log(value)
        setUserData(value?.data?.data_list || [])
        setTotalPage(value?.data?.pageMeta.totalPages || 1)        
      }
    }))
   },[sortOptions,currentPage,refresh])
  
    return (
      <div className="manageUsersContainer">
        <div className="manageUsersTableContainer">
        <h2>Manage Users</h2>
         <NormalTable headerDetails={headerDetails}>
         {userData.length > 0 ? userData.map((user,index) =>(
           <tr key={index} style={{ position: "relative" }}>
        <td>{(currentPage - 1) * 10 + (index + 1)}</td>
        <td>{user?.firstname}</td>
        <td>{user?.mobile}</td>
        <td>{user?.email}</td>
        <td>{user?.position_name}</td>
        <td>{user?.added_by}</td>
        <td>
        <button 
          style={{cursor:"pointer"}} 
          className='sendInviteButoon' 
          onClick={() => {
          if (!user?.mobile) {
            setIsModalOpen(true);
          } else {
            sendInvite(user?.user_id, user?.email);
          }
          }}
        >
         Send Invite
        </button>
        </td>
      </tr>
         )):''}
       </NormalTable>
       {userData.length > 0 ? '' :<p style={{textAlign:'center', fontFamily:'poppins', fontSize:"4vh", color: 'gray'}}>No Data Found</p>}
       {userData.length > 0 ?
       <Pagination
        currentPage={currentPage}
        totalPages={totalPage}
        onPageChange={handlePageChange}
        /> : ""}
        </div>
        <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
          <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Please fill the details in User Management <br/>before sending invite.</h3>
        <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
          {/* <Button
            buttonStyle={{
            height: "2vh",
            backgroundColor: "#FFFFFF",
            border: "1px solid black",
            width: "40%",
            }}
            titleStlye={{ color: "#888888" }}
            title="Ok"
            onClick={() => setIsModalOpen(false)}
          /> */}
        </div>
        </Modal>
      </div>
    );
}

export default ManageUsers;
